<template>
  <div class="column is-half-tablet is-one-third-desktop">
    <div class="box">
      <p>
        {{ name }}

        <button
          class="button is-pulled-right is-small"
          @click="$emit('edit-vending-category')"
        >
          <b-icon icon="edit"></b-icon>
        </button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name"]
};
</script>
